import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAwsServicesDayMeasures } from "./finops-aws-services.model";
import { DateGranularityEnum } from "src/app/shared/enum/date-granularity.enum";

@Injectable({
    providedIn: 'root'
})
export class FinOpsAwsServicesService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
    ) {
    }

    loadFinOpsAwsServicesHistoricalData(granularity: DateGranularityEnum, accountId: string, date: string) {
        return this.httpClient.get<FinOpsAwsServicesDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/services?date=${date}&granularity=${granularity}&account=${accountId}`)
    }

    loadFinOpsAwsServicesMeasures(date: string, accountId: string) {
        return this.httpClient.get<FinOpsAwsServicesDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/services/measures?date=${date}&account=${accountId}`)
    }
}
